import { IModel, Model } from './Model';

export interface IVisitCompletionTypeModel extends IModel {
  visitCompletionTypeId: number;
  name: string;
  isComplete: boolean;
  isManuallyAssignable: boolean;
  businessLineId: number;
}

export class VisitCompletionTypeModel
  extends Model
  implements IVisitCompletionTypeModel
{
  visitCompletionTypeId: number;
  name: string;
  isComplete: boolean;
  isManuallyAssignable: boolean;
  businessLineId: number;
  constructor(params: IVisitCompletionTypeModel) {
    super(params);
    this.visitCompletionTypeId = params.visitCompletionTypeId;
    this.name = params.name;
    this.isComplete = params.isComplete;
    this.isManuallyAssignable = params.isManuallyAssignable;
    this.businessLineId = params.businessLineId;
  }
}
